import { HttpRequest } from './HttpRequest'

export interface IGetProjectLists {
    message: string
    responseData: IGetProjectListsData[]
    prospectId: number
}

export interface IGetProjectListsData {
    id: string
    code: string
    name: string
    isActive: string
    productId: string
}

export const GetProjectLists = async () => {
    try { 
        const response = await HttpRequest().get(`/project/lists`)
        if (response.data.message === 'OK') {
            const result: IGetProjectLists = response.data.responseData
            return result
        }
        return []
    } catch (error: any) {
        throw new Error('ไม่สามารถโหลดข้อมูลโครงการได้ กรุณาลองเข้าใหม่')
    }
}